// extracted by mini-css-extract-plugin
export default {"statsBar":"Stats_statsBar__-jk3n"};